export default function UnderReview() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'var(--background-color, #0C0C0C)',
      color: 'var(--text-color-1, #FFFFFF)',
      fontFamily: 'Poppins, sans-serif',
      padding: '1rem',
      textAlign: 'center',
    }}>
      {/* Success Icon */}
      <div style={{
        width: 96,
        height: 96,
        borderRadius: '50%',
        backgroundColor: '#049567',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '1.5rem',
      }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>

      {/* Heading */}
      <h1 style={{
        fontSize: '1.5rem',
        fontWeight: 700,
        marginBottom: '0.5rem',
        color: 'var(--text-color-1, #FFFFFF)',
      }}>
        Thank You!
      </h1>

      {/* Subtext */}
      <p style={{
        fontSize: '1rem',
        fontWeight: 400,
        color: 'var(--text-color-2, #BBBBBB)',
        maxWidth: 400,
        lineHeight: 1.5,
      }}>
        Your request has been successfully registered and is currently under review. 
        We will notify you once it has been processed.
      </p>

      {/* Optional Button */}
      <button
        onClick={() => window.location.href = '/'}
        style={{
          marginTop: '2rem',
          padding: '0.75rem 1.5rem',
          fontSize: '1rem',
          fontWeight: 600,
          backgroundColor: '#049567',
          color: '#FFFFFF',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
        }}
      >
        Go to Home
      </button>
    </div>
  );
}
